import "../stylesheets/footer.css";

const Footer = () => {
  return <p>© Alekey Chernyakhovskiy | All rights reserved</p>;
};

export default Footer;
